// Sarasota Housing Authority — data for the temporary /calculator/sarasota mockup.
// Generated 2026-10-14 from SHA's published PDFs (see sources below). Do not hand-edit;
// regenerate from MASTER HOUSE/ua-pdfs-2026-10-14/sarasota-hcv-ua-schedule when SHA
// publishes a new schedule.
//
// Utility allowances: form HUD-52667, one schedule per county, 5 unit types x 0-5 BR,
//   effective 01/01/2026 - 12/31/2026.
// Payment standards: SAFMR-based, by ZIP, effective 07/01/2026, 0-4 BR.
// Minimum rent: $50 (HCV Administrative Plan, 24 CFR 5.630).

export const SARASOTA = {
  slug: "sarasota",
  name: "Sarasota Housing Authority",
  shortName: "SHA",
  themeColor: "#164d78",
  phone: "941-361-6210",
  website: "https://sarasotahousing.org",
  portals: {
    applicant: "https://www.pha-web.com/portals/applicant/1486",
    waitingList: "https://www.pha-web.com/portals/waitingListStatus/1486",
    family: "https://www.pha-web.com/portals/family/1486",
    landlord: "https://www.pha-web.com/portals/landlord/1486",
  },
  minimumRent: 50,
  ua: {
    effective: "January 1 - December 31, 2026",
    sources: {
      "Sarasota County": "https://sarasotahousing.org/documents/section8/UtilityAllowancesSarasota2026.pdf",
      "Manatee County": "https://sarasotahousing.org/documents/section8/UtilityAllowancesManateeCounty2026.pdf",
    },
    bedrooms: [0, 1, 2, 3, 4, 5],
    unitTypes: ["MOBILE HOME","SINGLE FAMILY","DUPLEX","LOW RISE/TOWNHOUSE/ROWHOUSE","HIGH RISE/MULTI-FAMILY/MULTI-STORY"],
    // county -> unit type -> line item -> [0BR..5BR]
    schedules: {
      "Sarasota County": {
        "MOBILE HOME": {
          "Heating - Natural Gas": [
            6,
            7,
            7,
            10,
            12,
            16
          ],
          "Heating - Bottled Gas": [
            18,
            22,
            24,
            31,
            37,
            52
          ],
          "Heating - Electric": [
            9,
            11,
            12,
            15,
            18,
            26
          ],
          "Heating - Electric - Heat Pump": [
            3,
            4,
            6,
            6,
            7,
            10
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            16,
            19,
            20,
            27,
            32,
            43
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "Water Heating - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "Water Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            44,
            55,
            66,
            79,
            101,
            119
          ],
          "Sewer": [
            62,
            76,
            90,
            104,
            122,
            132
          ],
          "Trash Collection": [
            25,
            25,
            25,
            25,
            25,
            25
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        },
        "SINGLE FAMILY": {
          "Heating - Natural Gas": [
            9,
            10,
            10,
            11,
            14,
            21
          ],
          "Heating - Bottled Gas": [
            27,
            30,
            31,
            36,
            43,
            67
          ],
          "Heating - Electric": [
            13,
            15,
            15,
            18,
            21,
            33
          ],
          "Heating - Electric - Heat Pump": [
            5,
            6,
            6,
            7,
            8,
            13
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            19,
            21,
            25,
            29,
            35,
            43
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "Water Heating - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "Water Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            44,
            55,
            66,
            79,
            101,
            119
          ],
          "Sewer": [
            62,
            76,
            90,
            104,
            122,
            132
          ],
          "Trash Collection": [
            25,
            25,
            25,
            25,
            25,
            25
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        },
        "DUPLEX": {
          "Heating - Natural Gas": [
            6,
            7,
            8,
            9,
            10,
            19
          ],
          "Heating - Bottled Gas": [
            20,
            22,
            24,
            29,
            32,
            61
          ],
          "Heating - Electric": [
            10,
            11,
            12,
            14,
            16,
            30
          ],
          "Heating - Electric - Heat Pump": [
            4,
            4,
            5,
            5,
            6,
            12
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            17,
            18,
            22,
            26,
            30,
            42
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "` - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "` - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            44,
            55,
            66,
            79,
            101,
            119
          ],
          "Sewer": [
            62,
            76,
            90,
            104,
            122,
            132
          ],
          "Trash Collection": [
            25,
            25,
            25,
            25,
            25,
            25
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        },
        "LOW RISE/TOWNHOUSE/ROWHOUSE": {
          "Heating - Natural Gas": [
            7,
            8,
            9,
            15,
            16,
            17
          ],
          "Heating - Bottled Gas": [
            21,
            25,
            28,
            47,
            52,
            55
          ],
          "Heating - Electric": [
            10,
            12,
            14,
            23,
            26,
            27
          ],
          "Heating - Electric - Heat Pump": [
            4,
            5,
            5,
            9,
            10,
            11
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            17,
            21,
            24,
            32,
            38,
            40
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "` - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "` - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            44,
            55,
            66,
            79,
            101,
            119
          ],
          "Sewer": [
            62,
            76,
            90,
            104,
            122,
            132
          ],
          "Trash Collection": [
            25,
            25,
            25,
            25,
            25,
            25
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        },
        "HIGH RISE/MULTI-FAMILY/MULTI-STORY": {
          "Heating - Natural Gas": [
            5,
            6,
            8,
            9,
            11,
            14
          ],
          "Heating - Bottled Gas": [
            15,
            20,
            26,
            29,
            34,
            43
          ],
          "Heating - Electric": [
            8,
            10,
            13,
            14,
            17,
            21
          ],
          "Heating - Electric - Heat Pump": [
            3,
            4,
            5,
            5,
            6,
            8
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            15,
            21,
            24,
            29,
            35,
            40
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "` - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "` - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            44,
            55,
            66,
            79,
            101,
            119
          ],
          "Sewer": [
            62,
            76,
            90,
            104,
            122,
            132
          ],
          "Trash Collection": [
            25,
            25,
            25,
            25,
            25,
            25
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        }
      },
      "Manatee County": {
        "MOBILE HOME": {
          "Heating - Natural Gas": [
            6,
            7,
            7,
            10,
            12,
            16
          ],
          "Heating - Bottled Gas": [
            18,
            22,
            24,
            31,
            37,
            52
          ],
          "Heating - Electric": [
            9,
            11,
            12,
            15,
            18,
            26
          ],
          "Heating - Electric - Heat Pump": [
            3,
            4,
            6,
            6,
            7,
            10
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            16,
            19,
            20,
            27,
            32,
            43
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "Water Heating - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "Water Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            28,
            34,
            40,
            47,
            57,
            63
          ],
          "Sewer": [
            48,
            57,
            66,
            75,
            85,
            89
          ],
          "Trash Collection": [
            21,
            21,
            21,
            21,
            21,
            21
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        },
        "SINGLE FAMILY": {
          "Heating - Natural Gas": [
            9,
            10,
            10,
            11,
            14,
            21
          ],
          "Heating - Bottled Gas": [
            27,
            30,
            31,
            36,
            43,
            67
          ],
          "Heating - Electric": [
            13,
            15,
            15,
            18,
            21,
            33
          ],
          "Heating - Electric - Heat Pump": [
            5,
            6,
            6,
            7,
            8,
            13
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            19,
            21,
            25,
            29,
            35,
            43
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "Water Heating - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "Water Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            28,
            34,
            40,
            47,
            57,
            63
          ],
          "Sewer": [
            48,
            57,
            66,
            75,
            85,
            89
          ],
          "Trash Collection": [
            21,
            21,
            21,
            21,
            21,
            21
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        },
        "DUPLEX": {
          "Heating - Natural Gas": [
            6,
            7,
            8,
            9,
            10,
            19
          ],
          "Heating - Bottled Gas": [
            20,
            22,
            24,
            29,
            32,
            61
          ],
          "Heating - Electric": [
            10,
            11,
            12,
            14,
            16,
            30
          ],
          "Heating - Electric - Heat Pump": [
            4,
            4,
            5,
            5,
            6,
            12
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            17,
            18,
            22,
            26,
            30,
            42
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "` - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "` - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            28,
            34,
            40,
            47,
            57,
            63
          ],
          "Sewer": [
            48,
            57,
            66,
            75,
            85,
            89
          ],
          "Trash Collection": [
            21,
            21,
            21,
            21,
            21,
            21
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        },
        "LOW RISE/TOWNHOUSE/ROWHOUSE": {
          "Heating - Natural Gas": [
            7,
            8,
            9,
            15,
            16,
            17
          ],
          "Heating - Bottled Gas": [
            21,
            25,
            28,
            47,
            52,
            55
          ],
          "Heating - Electric": [
            10,
            12,
            14,
            23,
            26,
            27
          ],
          "Heating - Electric - Heat Pump": [
            4,
            5,
            5,
            9,
            10,
            11
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            17,
            21,
            24,
            32,
            38,
            40
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "` - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "` - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            28,
            34,
            40,
            47,
            57,
            63
          ],
          "Sewer": [
            48,
            57,
            66,
            75,
            85,
            89
          ],
          "Trash Collection": [
            21,
            21,
            21,
            21,
            21,
            21
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        },
        "HIGH RISE/MULTI-FAMILY/MULTI-STORY": {
          "Heating - Natural Gas": [
            5,
            6,
            8,
            9,
            11,
            14
          ],
          "Heating - Bottled Gas": [
            15,
            20,
            26,
            29,
            34,
            43
          ],
          "Heating - Electric": [
            8,
            10,
            13,
            14,
            17,
            21
          ],
          "Heating - Electric - Heat Pump": [
            3,
            4,
            5,
            5,
            6,
            8
          ],
          "Heating - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Heating - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Cooking - Natural Gas": [
            6,
            8,
            12,
            13,
            16,
            19
          ],
          "Cooking - Bottled Gas": [
            18,
            26,
            33,
            41,
            52,
            59
          ],
          "Cooking - Electric": [
            6,
            9,
            11,
            14,
            17,
            23
          ],
          "Cooking - Other": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Other Electric": [
            34,
            40,
            45,
            50,
            59,
            65
          ],
          "Air Conditioning": [
            15,
            21,
            24,
            29,
            35,
            40
          ],
          "Water Heating - Natural Gas": [
            38,
            44,
            50,
            57,
            66,
            72
          ],
          "Water Heating - Bottled Gas": [
            56,
            75,
            94,
            114,
            143,
            162
          ],
          "Water Heating - Electric": [
            19,
            27,
            34,
            42,
            61,
            70
          ],
          "` - Electric - Heat Pump": [
            5,
            7,
            9,
            10,
            15,
            17
          ],
          "` - Fuel Oil": [
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "Water": [
            28,
            34,
            40,
            47,
            57,
            63
          ],
          "Sewer": [
            48,
            57,
            66,
            75,
            85,
            89
          ],
          "Trash Collection": [
            21,
            21,
            21,
            21,
            21,
            21
          ],
          "Other - specify - MEDICAL": [
            31,
            31,
            31,
            36,
            36,
            36
          ],
          "Range/Microwave": [
            6,
            6,
            6,
            6,
            6,
            6
          ],
          "Refrigerator": [
            6,
            6,
            6,
            6,
            6,
            6
          ]
        }
      }
    },
  },
  paymentStandards: {
    effective: "July 1, 2026",
    source: "https://sarasotahousing.org/documents/section8/PaymentStandardsAllCounty20260626.pdf",
    bedrooms: [0, 1, 2, 3, 4],
    // ZIP -> [0BR, 1BR, 2BR, 3BR, 4BR]
    byZip: {
      "33598": [
        1350,
        1457,
        1713,
        2194,
        2664
      ],
      "33834": [
        891,
        891,
        1133,
        1507,
        1764
      ],
      "34201": [
        1724,
        2163,
        2518,
        3302,
        3950
      ],
      "34202": [
        1872,
        2299,
        2664,
        3448,
        4117
      ],
      "34203": [
        1207,
        1499,
        1755,
        2299,
        2717
      ],
      "34204": [
        1315,
        1644,
        1912,
        2508,
        2988
      ],
      "34205": [
        1110,
        1381,
        1606,
        2131,
        2539
      ],
      "34206": [
        1315,
        1644,
        1912,
        2508,
        2988
      ],
      "34207": [
        1185,
        1473,
        1726,
        2279,
        2696
      ],
      "34208": [
        1257,
        1561,
        1828,
        2372,
        2831
      ],
      "34209": [
        1588,
        1891,
        2194,
        2842,
        3396
      ],
      "34210": [
        1250,
        1527,
        1830,
        2393,
        2863
      ],
      "34211": [
        1810,
        2183,
        2549,
        3331,
        3974
      ],
      "34212": [
        1747,
        2078,
        2434,
        3212,
        3830
      ],
      "34215": [
        1350,
        1654,
        1964,
        2591,
        3103
      ],
      "34216": [
        1598,
        1901,
        2204,
        2852,
        3442
      ],
      "34217": [
        1598,
        1901,
        2204,
        2852,
        3442
      ],
      "34219": [
        1911,
        2359,
        2747,
        3556,
        4252
      ],
      "34220": [
        1315,
        1644,
        1912,
        2508,
        2988
      ],
      "34221": [
        1306,
        1623,
        1901,
        2466,
        2936
      ],
      "34222": [
        1271,
        1525,
        1776,
        2299,
        2748
      ],
      "34223": [
        1165,
        1376,
        1615,
        2122,
        2515
      ],
      "34224": [
        1128,
        1139,
        1431,
        1985,
        2332
      ],
      "34228": [
        1976,
        2474,
        2890,
        3746,
        4465
      ],
      "34229": [
        1616,
        2001,
        2327,
        3018,
        3597
      ],
      "34230": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "34231": [
        1353,
        1672,
        1947,
        2527,
        3011
      ],
      "34232": [
        1501,
        1846,
        2143,
        2775,
        3309
      ],
      "34233": [
        1420,
        1705,
        1985,
        2571,
        3068
      ],
      "34234": [
        1209,
        1495,
        1749,
        2267,
        2701
      ],
      "34235": [
        1732,
        2063,
        2394,
        3100,
        3705
      ],
      "34236": [
        1766,
        2100,
        2445,
        3166,
        3782
      ],
      "34237": [
        1263,
        1577,
        1836,
        2392,
        2838
      ],
      "34238": [
        1679,
        2052,
        2455,
        3176,
        3793
      ],
      "34239": [
        1367,
        1656,
        1955,
        2577,
        3082
      ],
      "34240": [
        1795,
        2138,
        2481,
        3212,
        3835
      ],
      "34241": [
        1695,
        2100,
        2455,
        3176,
        3793
      ],
      "34242": [
        1995,
        2464,
        2857,
        3706,
        4421
      ],
      "34243": [
        1741,
        2109,
        2508,
        3249,
        3876
      ],
      "34249": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "34250": [
        1317,
        1645,
        1923,
        2498,
        2968
      ],
      "34251": [
        1463,
        1714,
        1985,
        2589,
        3077
      ],
      "34260": [
        1315,
        1644,
        1912,
        2508,
        2988
      ],
      "34264": [
        1317,
        1645,
        1923,
        2498,
        2968
      ],
      "34266": [
        1097,
        1285,
        1557,
        2069,
        2466
      ],
      "34270": [
        1315,
        1644,
        1912,
        2508,
        2988
      ],
      "34272": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "34274": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "34275": [
        1338,
        1657,
        1925,
        2513,
        3004
      ],
      "34276": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "34277": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "34280": [
        1315,
        1644,
        1912,
        2508,
        2988
      ],
      "34282": [
        1315,
        1644,
        1912,
        2508,
        2988
      ],
      "34284": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "34285": [
        1259,
        1546,
        1811,
        2350,
        2805
      ],
      "34286": [
        1892,
        2208,
        2607,
        3377,
        4026
      ],
      "34287": [
        1208,
        1449,
        1687,
        2208,
        2645
      ],
      "34288": [
        1687,
        2001,
        2327,
        3018,
        3597
      ],
      "34289": [
        1557,
        1849,
        2152,
        2790,
        3323
      ],
      "34290": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "34291": [
        1704,
        2020,
        2348,
        3047,
        3627
      ],
      "34292": [
        1417,
        1741,
        2021,
        2617,
        3122
      ],
      "34293": [
        1534,
        1846,
        2143,
        2802,
        3373
      ],
      "34295": [
        1377,
        1672,
        1947,
        2527,
        3011
      ],
      "DeSoto County": [
        1158,
        1166,
        1329,
        1829,
        2051
      ]
    },
  },
  // ZIPs on SHA's list that lie in Manatee County; every other listed ZIP uses the
  // Sarasota County schedule (SHA publishes only these two).
  manateeZips: ["34201","34202","34203","34204","34205","34206","34207","34208","34209","34210","34211","34212","34215","34216","34217","34219","34220","34221","34222","34243","34250","34251","34260","34264","34270","34280","34282"],
};

export function countyForZip(zip) {
  return SARASOTA.manateeZips.includes(zip) ? "Manatee County" : "Sarasota County";
}
